module.exports = __webpack_public_path__ + "img/b8.7796610a.png";